var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.RXPlayer = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getPosition()
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    if (this.flags.isPaused) return 0
    return this.player.getPlaybackRate()
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.getVideoDuration()
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    return this.player.getVideoBitrate()
  },

  /** Override to return rendition */
  getRendition: function () {
    youbora.Util.buildRenditionString(this.player.getVideoBitrate())
  },

  /** Override to return title */
  getTitle: function () {
    return 'unknown'
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.isLive()
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.getUrl()
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return this.player.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Rx-player'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    this.monitorPlayhead(true, false)
    // References
    this.references = []
    this.references['playerStateChange'] = this.stateChangeListener.bind(this)
    this.references['warning'] = this.warningListener.bind(this)
    this.references['error'] = this.errorListener.bind(this)
    this.references['positionUpdate'] = this.positionUpdateListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },
  /** Listener for 'positionUpdate' event. */
  positionUpdateListener: function (e) {
    if (e.position > 0.1) {
      this.fireJoin()
      this.fireStart()
    }
  },

  /** Listener for 'warning' event. */
  warningListener: function (e) {
    this.fireError()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError()
    this.fireStop()
  },

  /** Listener for 'playerStateChange' event. */
  stateChangeListener: function (e) {
    youbora.Log.debug(e)
    switch (e) {
      // case 'LOADED':
      case 'LOADING':
        if (this.player.videoElement.autoplay)
          this.fireStart()
        break
      case 'BUFFERING':
        //this.fireBufferBegin()
        break
      case 'SEEKING':
        this.fireSeekBegin()
        break
      case 'PLAYING':
        this.fireStart()
        this.fireResume()
        //this.fireBufferEnd()
        this.fireSeekEnd()
        break
      case 'PAUSED':
        this.firePause()
        break
      case 'ENDED':
      case 'STOPPED':
        setTimeout(function () {
          this.fireStop()
        }.bind(this), 200)
    }
  }
})

module.exports = youbora.adapters.RXPlayer
